import React, { useState, useEffect } from 'react';

export default function Home() {
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    const video = document.getElementById('background-video');
    if (video) video.playbackRate = 3;
  }, []);

  const productItemStyle = {
    position: 'relative',
    height: '80vh',
    overflow: 'hidden',
    margin: 0,
    padding: 0,
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 0.5s ease',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)', // dark transparent overlay
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    textAlign: 'center',
    transition: 'background 0.3s ease',
  };

  const logoStyle = {
    width: '150px',
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '5px',
    marginBottom: '15px',
  };

  const titleStyle = {
    color: '#fff',
    fontSize: '1.8rem',
    margin: 0,
    fontWeight: '600',
  };

  const buttonWrapperStyle = {
    marginTop: '40px',
  };

  const buttonBaseStyle = {
    backgroundColor: '#722f37',
    color: '#fff',
    padding: '14px 40px',
    borderRadius: '30px',
    border: 'none',
    fontWeight: '600',
    fontSize: '1.1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(114, 47, 55, 0.4)',
  };

  // Unified card hover (image zoom + darker overlay)
  const handleCardHover = (e, isEnter) => {
    const img = e.currentTarget.querySelector('img'); // background product image
    const overlay = e.currentTarget.querySelector('.overlay');
    if (img) {
      img.style.transform = isEnter ? 'scale(1.05)' : 'scale(1)';
    }
    if (overlay) {
      overlay.style.background = isEnter ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.3)';
    }
  };

  // Button hover (darker wine + lift)
  const handleButtonHover = (e, isEnter) => {
    e.currentTarget.style.backgroundColor = isEnter ? '#5a1f2b' : '#722f37';
    e.currentTarget.style.transform = isEnter ? 'translateY(-3px)' : 'translateY(0)';
    e.currentTarget.style.boxShadow = isEnter ? '0 8px 25px rgba(114, 47, 55, 0.5)' : '0 4px 15px rgba(114, 47, 55, 0.4)';
  };

  return (
    <>
      <video
        style={{
          position: 'absolute',
          height: '100vh',
          width: '100vw',
          objectFit: 'cover',
          zIndex: -1,
        }}
        id="background-video"
        autoPlay
        muted
        loop={false}
        onEnded={() => setShowPage(true)}
      >
        <source src="./assets/images/video/EDGE INFINIUM 04.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div id="content" style={{ display: !showPage ? 'none' : 'block' }}>
        <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
          <header id="navbar-spy1" className="header header-4 header-light d-none d-lg-block">
            <nav className="navbar logo-centered">
              <div className="container">
                <div className="navbar-brand" style={{ paddingBottom: 30, paddingTop: 30 }}>
                  <img className="logo" style={{ height: 93 }} src="assets/images/logo/EI.png" alt="logo" />
                </div>
              </div>
            </nav>
          </header>

          <section id="products-carousel2" className="products-carousel products-carousel-2 pt-0 pb-0">
            <div className="container-fluid pr-0 pl-0">
              <div className="row no-gutters" style={{ margin: 15 }}>
                {/* 1️⃣ Husk 'n' Spices */}
                <div className="col-sm-12 col-md-4 col-lg-3 p-0">
                  <a
                    href="/husk-n-spices"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', display: 'block', cursor: 'pointer' }}
                    onMouseEnter={e => handleCardHover(e, true)}
                    onMouseLeave={e => handleCardHover(e, false)}
                  >
                    <div className="product-item" style={productItemStyle}>
                      <img src="assets/images/products/carousel/4.jpg" alt="Husk 'n' Spices" style={imageStyle} />
                      <div className="overlay" style={overlayStyle}>
                        <img src="assets/images/logo/EI.png" alt="Company Logo" style={logoStyle} />
                        <h3 style={titleStyle}>Husk 'n' Spices</h3>
                        <div style={buttonWrapperStyle}>
                          <button
                            style={buttonBaseStyle}
                            onMouseEnter={e => handleButtonHover(e, true)}
                            onMouseLeave={e => handleButtonHover(e, false)}
                          >
                            Click Here
                          </button>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* 2️⃣ The Cattle Feed */}
                <div className="col-sm-12 col-md-4 col-lg-3 p-0">
                  <a
                    href="/cattle-feed"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', display: 'block', cursor: 'pointer' }}
                    onMouseEnter={e => handleCardHover(e, true)}
                    onMouseLeave={e => handleCardHover(e, false)}
                  >
                    <div className="product-item" style={productItemStyle}>
                      <img src="assets/images/products/carousel/1.jpg" alt="Cattle Feed" style={imageStyle} />
                      <div className="overlay" style={overlayStyle}>
                        <img src="assets/images/logo/The cattle Feed fl-01.png" alt="Company Logo" style={logoStyle} />
                        <h3 style={titleStyle}>
                          The Cattle Feed <br /> The Animal Feed
                        </h3>
                        <div style={buttonWrapperStyle}>
                          <button
                            style={buttonBaseStyle}
                            onMouseEnter={e => handleButtonHover(e, true)}
                            onMouseLeave={e => handleButtonHover(e, false)}
                          >
                            Click Here
                          </button>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* 3️⃣ Agritech */}
                <div className="col-sm-12 col-md-4 col-lg-3 p-0">
                  <a
                    href="https://www.edgeinfiniumagritech.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', display: 'block', cursor: 'pointer' }}
                    onMouseEnter={e => handleCardHover(e, true)}
                    onMouseLeave={e => handleCardHover(e, false)}
                  >
                    <div className="product-item" style={productItemStyle}>
                      <img src="assets/images/products/carousel/edgeinfiniumagritech.jpg" alt="Agritech" style={imageStyle} />
                      <div className="overlay" style={overlayStyle}>
                        <img src="assets/images/logo/EI.png" alt="Company Logo" style={logoStyle} />
                        <h3 style={titleStyle}>Edge Infinium Agritech Solutions</h3>
                        <div style={buttonWrapperStyle}>
                          <button
                            style={buttonBaseStyle}
                            onMouseEnter={e => handleButtonHover(e, true)}
                            onMouseLeave={e => handleButtonHover(e, false)}
                          >
                            Click Here
                          </button>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* 4️⃣ Industrial */}
                <div className="col-sm-12 col-md-4 col-lg-3 p-0">
                  <a
                    href="https://www.edgeinfiniumindustrialsolutions.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', display: 'block', cursor: 'pointer' }}
                    onMouseEnter={e => handleCardHover(e, true)}
                    onMouseLeave={e => handleCardHover(e, false)}
                  >
                    <div className="product-item" style={productItemStyle}>
                      <img src="assets/images/products/carousel/edgeindustrial.jpg" alt="Industrial" style={imageStyle} />
                      <div className="overlay" style={overlayStyle}>
                        <img src="assets/images/logo/EI.png" alt="Company Logo" style={logoStyle} />
                        <h3 style={titleStyle}>Edge Infinium Industrial Solutions</h3>
                        <div style={buttonWrapperStyle}>
                          <button
                            style={buttonBaseStyle}
                            onMouseEnter={e => handleButtonHover(e, true)}
                            onMouseLeave={e => handleButtonHover(e, false)}
                          >
                            Click Here
                          </button>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* 5️⃣ Software */}
                <div className="col-sm-12 col-md-4 col-lg-3 p-0">
                  <a
                    href="https://www.edgeinfiniumsoftwaresolutions.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', display: 'block', cursor: 'pointer' }}
                    onMouseEnter={e => handleCardHover(e, true)}
                    onMouseLeave={e => handleCardHover(e, false)}
                  >
                    <div className="product-item" style={productItemStyle}>
                      <img src="assets/images/products/carousel/edgeinfinimsoftwaresolutions.jpg" alt="Software" style={imageStyle} />
                      <div className="overlay" style={overlayStyle}>
                        <img src="assets/images/logo/EI.png" alt="Company Logo" style={logoStyle} />
                        <h3 style={titleStyle}>Edge Infinium Software Solutions</h3>
                        <div style={buttonWrapperStyle}>
                          <button
                            style={buttonBaseStyle}
                            onMouseEnter={e => handleButtonHover(e, true)}
                            onMouseLeave={e => handleButtonHover(e, false)}
                          >
                            Click Here
                          </button>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
